import { isExtensionStack, isNoiseExceptionMessage } from 'lib/error-noise'

/** True for errors the New Relic browser agent should drop instead of reporting. */
export const isNewRelicNoise = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return isNoiseExceptionMessage(error)
  }
  const { message, stack } = (error ?? {}) as { message?: unknown; stack?: unknown }
  return (
    (typeof message === 'string' && isNoiseExceptionMessage(message)) ||
    (typeof stack === 'string' && isExtensionStack(stack))
  )
}

const registerErrorHandler = (): void => {
  window.newrelic?.setErrorHandler(isNewRelicNoise)
}

// The bundle's async script tags come before the parser-blocking agent script, so the bundle can
// run first. The agent has always run by DOMContentLoaded. Outside production it never loads.
export const init = (): void => {
  if (!window.newrelic && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerErrorHandler, { once: true })
    return
  }
  registerErrorHandler()
}
